import { connect } from "react-redux";
import ChangeAssingee from "./Change";
import { bindActionCreators } from "redux";
import {fetchPmAssignee} from "services/redux/maintenance/pmTicket/action";
import {pmSoftwareUpdateAssignee} from "../../../../services/redux/maintenance/pmSities/action";
import {engineerList} from "../../../../services/redux/maintenance/pmList/action";
const mapStateToProps = (state) => ({
    pmAssigneeList: state.pmListReducer.engineerListData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            engineerList,
            pmSoftwareUpdateAssignee,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ChangeAssingee);
